import React, { useEffect, useRef } from "react";
import main from "../../../images/Garantie/main.jpg";
import gr1 from "../../../images/Garantie/gr1.jpg";
import gr2 from "../../../images/Garantie/gr2.jpg";
import gr3 from "../../../images/Garantie/gr3.jpg";
import { FiPhone, FiMail } from "react-icons/fi";
import "./Garantie.css";

export default function Garantie({navigateWithTransition}) {
const sectionRef = useRef(null);
useEffect(() => {
  const section = sectionRef.current;
  if (!section) return;

  const elements = section.querySelectorAll(".reveal-on-scroll");

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -8% 0px",
    }
  );

  elements.forEach((el) => revealObserver.observe(el));

  return () => revealObserver.disconnect();
}, []);


 return (
    <div className="garantie-page" ref={sectionRef}>
      <div className="top-section">
        <h1 className="reveal-on-scroll reveal-soft">Quelles sont les garanties de ma cuisine ?</h1>

       <p className="intro reveal-on-scroll reveal-soft delay-1">
          Chez <span>ELEMENTS GROUP</span>, nous accordons une grande importance
          à la qualité et à la durabilité de nos réalisations. C’est pourquoi
          nous offrons des garanties adaptées à chacun de nos produits et
          services.
        </p>

      <div className="cards">

  {/* Card 1 */}
 <div className="card reveal-on-scroll reveal-soft delay-1">
    <div className="card-image">
      <img src={gr1} alt="Meubles sur mesure" />

      <div className="card-title">
        <h3>Meubles sur mesure</h3>
      </div>
    </div>

    <h4>Garantie : 7 ans</h4>

    <p>
      Valable à compter de la date de réception du projet, cette
      garantie couvre l’ensemble de nos réalisations sur mesure contre
      tout défaut de fabrication ou d’assemblage.
    </p>
  </div>

  {/* Card 2 */}
 <div className="card reveal-on-scroll reveal-soft delay-2">
    <div className="card-image">
      <img src={gr2} alt="Plans de travail" />

      <div className="card-title">
        <h3>Plans de travail</h3>
      </div>
    </div>

    <h4>Garantie : 2 ans</h4>

    <p>
      Nos plans de travail bénéficient d’une garantie couvrant les
      défauts liés à la fabrication et à l’installation.
    </p>
  </div>

  {/* Card 3 */}
<div className="card reveal-on-scroll reveal-soft delay-3">
    <div className="card-image">
      <img src={gr3} alt="Électroménagers" />

      <div className="card-title">
        <h3>Électroménagers</h3>
      </div>
    </div>

    <h4>Garantie : 2 ans</h4>

    <p>
      Les équipements électroménagers sont garantis conformément aux
      conditions du fabricant.
      Les produits Promodar bénéficient d’une garantie limitée d’un an.
    </p>
  </div>

</div>

       <div className="garantie-info reveal-on-scroll reveal-soft">
          <h3>Ce que couvre la garantie</h3>

         
            <p>*Défauts de fabrication et d’assemblage &nbsp;
            *Dégâts liés au transport &nbsp;
            *Assistance et suivi après installation</p>
          

          <h3>Ce que la garantie ne couvre pas</h3>

        
            <p>*L’usure normale des produits *Les dommages causés par une mauvaise utilisation
              *Un entretien inapproprié ou des modifications du produit
           
              *Les dommages liés à des événements extérieurs : incendie, dégâts
              des eaux, etc.
            </p>
      
        </div>
      </div>

      <div className="bottom-section">
       <div className="assistance-image reveal-on-scroll reveal-left">
          <img
            src={main}
            alt="Service"
          />

         
        </div>

       <div className="contact-box reveal-on-scroll reveal-right">
          <p className="subtitle">UN NUMÉRO UNIQUE</p>

          <h2>POUR VOUS SERVIR</h2>

       <div className="contact-info">
  <a href="tel:+21629067840" className="info-item">
    <FiPhone className="icon" />
    <span>29 067 840</span>
  </a>

  <a href="mailto:cdr@elements.tn" className="info-item">
    <FiMail className="icon" />
    <span>cdr@elements.tn</span>
  </a>
</div>
        </div>
      </div>
    </div>
  );

}